// extracted by mini-css-extract-plugin
module.exports = {"container":"_2YJonTmxqLTQkRPwZ5M4ko","title":"_2xFVmz3UF0f14QSxQaAqFO","content":"_2pyyHaFhnzKqCqyxhzcvsk"};